import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DragSource, DropTarget } from 'react-dnd'
import flow from 'lodash.flow';
import PropTypes from 'prop-types';

import { makeGetCurrentUser } from '../selectors/users';
import { makeGetTask } from '../selectors/tasks';
import { makeGetSortedActiveProjectTaskGroups, makeGetSortedActiveProjectTaskGroupsWithTasks } from '../selectors/task-groups';

import { updateTask, assignTask, unassignTask } from '../actions/tasks';

import { canUser } from '../services/permissions-service';

import Popout from './popout';
import Select from './select';
import UsersList from './users-list';
import SubtaskSingle from './subtask-single';

import IconInvite from '../icons/icon-invite';

import Placeholder from './placeholders/subtask-item.placeholder';

import 'react-datepicker/dist/react-datepicker.css';

const subtaskSource = {
    beginDrag(props) {
        setTimeout(props.onDragStart && props.onDragStart);

        return {
            id: props.id,
            index: props.index
        }
    },

    endDrag(props) {
        props.onDragEnd && props.onDragEnd(props.id);
    },
    canDrag(props) {
        if (props.subtasksInEditMode.includes(props.id)) {
            return false
        }

        return true;
    }
}

const subtaskTarget = {
    drop(props, monitor, component) {
        props.moveSubtask && props.moveSubtask(monitor.getItem().id, props.id);
    },

    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        if (dragIndex === hoverIndex) {
            return;
        }

        props.moveSubtask(monitor.getItem().id, props.id, true)

        monitor.getItem().index = hoverIndex
    }
}

const UTIL_ACTION_ITEMS = [
    {
        text: 'Delete',
        payload: {
            action: 'delete'
        }
    },
    {
        text: 'Convert to a task',
        payload: {
            action: 'convertToTask'
        }
    },
    {
        text: 'Move into another task',
        payload: {
            action: 'moveToTask'
        }
    }
];

const NON_REMOVE_UTIL_ACTION_ITEMS = [
    {
        text: 'Convert to a task',
        payload: {
            action: 'convertToTask'
        }
    },
    {
        text: 'Move into another task',
        payload: {
            action: 'moveToTask'
        }
    }
];

class SubtaskHolder extends Component {
    static propTypes = {
        id: PropTypes.string,
        index: PropTypes.number,
        isDragging: PropTypes.bool,
        isOver: PropTypes.bool,
        taskGroups: PropTypes.any,
        subtask: PropTypes.any,
        onConvertToTask: PropTypes.func,
        onMoveToTask: PropTypes.func,
        onComplete: PropTypes.func,
        onUncomplete: PropTypes.func,
        onNameChange: PropTypes.func,
        onEnterPress: PropTypes.func,
        onDelete: PropTypes.func,
        onDragStart: PropTypes.func,
        onDragEnd: PropTypes.func,
        moveSubtask: PropTypes.func,
        connectDragPreview: PropTypes.func,
        connectDragSource: PropTypes.func,
        connectDropTarget: PropTypes.func,
        provideController: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            name: props.subtask && props.subtask.name,
            editing: false,
            utilActionDropdownVisible: false,
            moveToTaskSelectedTaskList: props.taskGroupsWithTasks.length && props.taskGroupsWithTasks[0].id
        };
    }

    handleConvertToTaskConfirmClick = () => {
        if (!this.props.onConvertToTask) {
            return;
        }

        this.convertToTaskPopoutCtrl && this.convertToTaskPopoutCtrl.hide();
        this.props.onConvertToTask(this.props.id, this.convertToTaskSelectCtrl.getValue(), this.state.name)
    }

    handleConvertToTaskCancelClick = () => {
        this.convertToTaskPopoutCtrl.hide();
    }

    handleMoveToTaskConfirmClick = () => {
        this.convertToTaskPopoutCtrl && this.convertToTaskPopoutCtrl.hide();
        this.props.onMoveToTask(this.props.id, this.moveToTaskTaskSelectCtrl.getValue(), this.state.name, this.props.subtask.completed);
    }

    handleMoveToTaskCancelClick = () => {
        this.moveToTaskPopoutCtrl.hide();
    }

    handleMoveToTaskTaskListSelect = item => {
        this.setState({
            moveToTaskSelectedTaskList: item.id
        });
    }

    handleComplete = () => {
        if (!canUser('editSubtask')) {
            return;
        }

        if (this.state.name === '') {
            this.beginEdit();

            return;
        }

        this.props.onComplete && this.props.onComplete(this.props.id);
    }

    handleUncomplete = () => {
        if (!canUser('editSubtask')) {
            return;
        }

        this.props.onUncomplete && this.props.onUncomplete(this.props.id);
    }

    handleSubtaskClick = () => {
        this.beginEdit();
    }

    handleAssigneeAdd = user => {
        assignTask(this.props.id, [user.id || user]);
    }

    handleAssigneeRemove = userId => {
        unassignTask(this.props.id, [userId]);
    }

    handleUtilClick = ({ payload }) => {
        switch (payload.action) {
            case 'delete':
                this.props.onDelete && this.props.onDelete(this.props.id);
                break;

            case 'convertToTask':
                this.convertToTaskPopoutCtrl.show();
                break;

            case 'moveToTask':
                this.moveToTaskPopoutCtrl.show();
                break;

            default:
                return null;
        }
    }

    handleDueDateChange = (subtaskId, date) => {
        updateTask(subtaskId, {
            due_date: date
        });
    }

    toggleEdit() {
        if (this.state.editing) {
            this.endEdit();
        } else {
            this.beginEdit();
        }
    }

    beginEdit() {
        this.subtaskCtrl && this.subtaskCtrl.beginEdit();
    }

    endEdit() {
        this.subtaskCtrl && this.subtaskCtrl.endEdit();
    }

    get selecteTaskGroupTasks() {
        if (!this.state.moveToTaskSelectedTaskList) {
            return [];
        }

        return this.props.tasks
            .filter(task => task.task_group === this.state.moveToTaskSelectedTaskList);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.id !== nextProps.id) return true;
        if (this.props.isDragging !== nextProps.isDragging) return true;
        if (this.props.isOver !== nextProps.isOver) return true;
        if (this.props.tasks !== nextProps.tasks) return true;
        if (this.props.taskGroups !== nextProps.taskGroups) return true;
        if (this.props.taskGroupsWithTasks !== nextProps.taskGroupsWithTasks) return true;
        if (this.props.subtask !== nextProps.subtask) return true;
        if (this.props.subtasksInEditMode !== nextProps.subtasksInEditMode) return true;
        if (this.state !== nextState) return true;

        return false;
    }

    componentDidUpdate(prevProps) {
        if (!this.state.moveToTaskSelectedTaskList && this.props.taskGroupsWithTasks.length) {
            this.setState({
                moveToTaskSelectedTaskList: this.props.taskGroupsWithTasks[0].id
            });
        }
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            beginEdit: () => {
                return this.beginEdit();
            },
            hasFocus: () => {
                return this.subtaskCtrl && this.subtaskCtrl.hasFocus();
            }
        });
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        const subtask = this.props.subtask;

        if ((!subtask && !this.props.new) || (subtask && subtask.loading)) {
            return <Placeholder />;
        }

        const element = <SubtaskSingle
            id={subtask && subtask.id}
            new={this.props.new}
            richPreview={this.props.richPreview}
            name={subtask && subtask.name}
            completed={subtask && subtask.completed}
            completedBy={subtask && subtask.completed && subtask.completed_by}
            completedOn={subtask && subtask.completed && subtask.completed_on}
            dueDate={subtask && subtask.due_date}
            assignees={subtask && subtask.assignees}
            namePlaceholder="Add a new subtask..."
            isDragging={this.props.isDragging}
            isOver={this.props.isOver}
            projectId={this.props.projectId}
            selectListDisabled={true}
            utilActions={!this.props.new && canUser('editSubtask') ? canUser('removeSubtask', [subtask && subtask.created_by]) ? UTIL_ACTION_ITEMS : NON_REMOVE_UTIL_ACTION_ITEMS : []}
            canEdit={canUser('editSubtask')}
            onClick={this.handleSubtaskClick}
            onUtilClick={this.handleUtilClick}
            onUncomplete={this.handleUncomplete}
            onComplete={this.handleComplete}
            onDelete={this.props.onDelete}
            onEditStart={this.props.onEditStart}
            onEditEnd={this.props.onEditEnd}
            onNameChange={this.props.onNameChange}
            onEnterPress={this.props.onEnterPress}
            onDueDateChange={!this.props.new && this.handleDueDateChange}
            provideController={ctrl => this.subtaskCtrl = ctrl}
            utilElements={!this.props.new && (
                <React.Fragment>
                    <Popout
                        provideController={ctrl => this.convertToTaskPopoutCtrl = ctrl}
                        className="dark-arrow xxsmall"
                        xAlign="right"
                        defaultXPosition="left"
                    >
                        <div className="popout-head">
                            CONVERT SUBTASK TO TASK
                        </div>

                        <div className="popout-main">
                            <div className="popout-body">
                                <Select
                                    label="Task List"
                                    provideController={ctrl => this.convertToTaskSelectCtrl = ctrl}
                                    options={this.props.taskGroups.map(taskGroup => ({ id: taskGroup.id, text: taskGroup.name }))}
                                />
                            </div>
                        </div>

                        <div className="popout-foot">
                            <div className="btn-group">
                                <button className="btn btn-small btn-secondary" onClick={this.handleConvertToTaskCancelClick}>Cancel</button>

                                <button className="btn btn-small btn-success" onClick={this.handleConvertToTaskConfirmClick}>Convert</button>
                            </div>
                        </div>
                    </Popout>

                    <Popout
                        provideController={ctrl => this.moveToTaskPopoutCtrl = ctrl}
                        className="dark-arrow xxsmall"
                        xAlign="right"
                        defaultXPosition="left"
                    >
                        <div className="popout-head">
                            MOVE SUBTASK INTO ANOTHER TASK
                        </div>

                        <div className="popout-main">
                            <div className="popout-body">
                                <Select
                                    label="Task List"
                                    provideController={ctrl => this.moveToTaskTaskListSelectCtrl = ctrl}
                                    options={this.props.taskGroupsWithTasks.map(taskGroup => ({ id: taskGroup.id, text: taskGroup.name }))}
                                    onSelect={this.handleMoveToTaskTaskListSelect}
                                />

                                <Select
                                    label="Task"
                                    provideController={ctrl => this.moveToTaskTaskSelectCtrl = ctrl}
                                    options={this.selecteTaskGroupTasks.map(task => ({ id: task.id, text: task.name }))}
                                />
                            </div>
                        </div>

                        <div className="popout-foot">
                            <div className="btn-group">
                                <button className="btn btn-small btn-secondary" onClick={this.handleMoveToTaskCancelClick}>Cancel</button>

                                <button className="btn btn-small btn-success" onClick={this.handleMoveToTaskConfirmClick}>Move</button>
                            </div>
                        </div>
                    </Popout>
                </React.Fragment>
            )}
            usersListElement={!this.props.new && (
                <UsersList
                    btnClassName="btn btn-square btn-xxxsmall btn-simple btn-icon btn-colored item-click-action"
                    popoutTitle="ASSIGN SUBTASK TO:"
                    projectId={this.props.projectId}
                    editable={canUser('assignToSubtask', [subtask.created_by])}
                    size="xxsmall"
                    users={subtask ? subtask.assignees : []}
                    maxUsersCount={3}
                    subtitles={canUser('unassignFromSubtask', [subtask.created_by]) ? 'Un-assign user' : null}
                    onSubtitleClick={this.handleAssigneeRemove}
                    excludedUsers={subtask ? subtask.assignees : []}
                    addUserIcon={<IconInvite size="10px" />}
                    onUserSelect={this.handleAssigneeAdd}
                />
            )}
        />

        if (this.props.moveSubtask && canUser('editSubtask') && this.props.onDragEnd && !this.props.subtasksInEditMode.includes(this.props.id)) {
            return this.props.connectDragSource(this.props.connectDropTarget(this.props.connectDragPreview(<div className="subtask-holder">{element}</div>, { captureDraggingState: true })))
        }

        return <div className="subtask-holder">{element}</div>;
    }
}


const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();
    const getTask = makeGetTask();
    const getSortedActiveProjectTaskGroups = makeGetSortedActiveProjectTaskGroups();
    const getSortedActiveProjectTaskGroupsWithTasks = makeGetSortedActiveProjectTaskGroupsWithTasks();

    return ({ taskGroups, tasks, users }, ownProps) => ({
        currentUser: getCurrentUser(users),
        tasks: tasks.items,
        taskGroups: ownProps.projectId ? getSortedActiveProjectTaskGroups(taskGroups.items, ownProps.projectId) : [],
        taskGroupsWithTasks: ownProps.projectId ? getSortedActiveProjectTaskGroupsWithTasks(taskGroups.items, tasks.items, ownProps.projectId) : [],
        subtask: (ownProps.id && getTask(tasks.items, ownProps.id)) || ownProps.subtask
    })
}

export default connect(makeMapStateToProps)(flow(
    DragSource('subtask', subtaskSource, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging()
    })),
    DropTarget('subtask', subtaskTarget, (connect, monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver()
    })),
)(SubtaskHolder));
